export enum GridSize {
    None = 'none',
    Grid10 = 10,
    Grid20 = 20,
    Grid50 = 50,
    Grid100 = 100,
    GridCustom = 'custom',
    GridFacebook = 'facebook'
}

export enum GridColor {
    BLACK = 'rgba(0, 0, 0, 0.5)',
    WHITE = 'rgba(255, 255, 255, 0.5)',
    GREEN = 'rgba(0, 128, 0, 0.5)',
    PURPLE = 'rgba(128, 0, 128, 0.5)'
}

export const OldToNuiGridColor = {
    [GridColor.BLACK]: 'nui-black',
    [GridColor.GREEN]: 'nui-green',
    [GridColor.PURPLE]: 'nui-red',
    [GridColor.WHITE]: 'nui-white'
} as const;

// TODO: add grid colors vars to figma to make sure it's consistent in dark mode
export const NuiGridColor = {
    'nui-black': '--nui-guidelines-grid-black',
    'nui-green': '--nui-guidelines-grid-green',
    'nui-red': '--nui-guidelines-grid-red',
    'nui-white': '--nui-guidelines-grid-white'
} as const;

export type NuiGridColorName = keyof typeof NuiGridColor;
